export default {
  namespaced: true,
  state: () => ({
    setIsLoading: false,
    generatedLabelUrl: null,
  }),

  actions: {
  },

  mutations: {
    SET_IS_LOADING(state, data) {
      state.setIsLoading = data;
    },

    SET_GENERATED_LABEL_URL(state, data) {
      state.generatedLabelUrl = data;
    },

  },

};
